import React from 'react';
import { CalendarDate, CalendarDateTime } from '@internationalized/date';
import type { StripControlledProperties } from '~/shared/forms/types';
import { DateField, type DateFieldProps } from '../../base-fields/DateField';
import { useFormField } from '~/shared/forms/useFormField';
import { convertFromDateFieldValue, convertToDateFieldValue } from '~/util/date';

export function DateFormField(props: StripControlledProperties<Omit<DateFieldProps<CalendarDate>, 'validate'>>) {
	const fieldProps = useFormField<Date | null>(props);
	const calendarDateValue = fieldProps.value ? convertToDateFieldValue(fieldProps.value, 'day') : null;

	const onChange = (newValue: CalendarDate | CalendarDateTime | null) => {
		fieldProps.onChange(newValue ? convertFromDateFieldValue(newValue) : null);
	};

	return <DateField {...props} {...fieldProps} granularity="day" value={calendarDateValue} onChange={onChange} />;
}
